// extracted by mini-css-extract-plugin
export var emailBlockLink = "_k9-0";